import InboxIcon from "@mui/icons-material/Inbox";
import FolderDeleteIcon from "@mui/icons-material/FolderDelete";
import DeleteIcon from "@mui/icons-material/Delete";
import OutboxIcon from "@mui/icons-material/Outbox";
import SentItemsFolderIcon from "@mui/icons-material/Send";
import DraftFolderIcon from "@mui/icons-material/DriveFileRenameOutline";
import ArchiveIcon from "@mui/icons-material/AccessTime";
import DLQIcon from "@mui/icons-material/SdCardAlert";
import GreylistFolderIcon from "@mui/icons-material/PauseCircleFilled";
import FolderIcon from "@mui/icons-material/Folder";
import Folder, {FolderTypeEnum} from "../domain/Folder";

export function getFolderIcon(icon: string) {
    switch (icon) {
        case "Inbox":
            return <InboxIcon/>;
        case "Deleted":
            return <FolderDeleteIcon/>;
        case "Junk":
            return <DeleteIcon/>;
        case "Outbox":
            return <OutboxIcon/>;
        case "SentItems":
            return <SentItemsFolderIcon/>;
        case "Drafts":
            return <DraftFolderIcon/>;
        case "Archive":
            return <ArchiveIcon/>;
        case "DLQ":
            return <DLQIcon/>;
        case "Greylist":
            return <GreylistFolderIcon/>;
    }
    return <FolderIcon/>;
}

export function isValidFolderForMovingEmail(folder: Folder) {
    return folder.type === FolderTypeEnum.UserMail || folder.type === FolderTypeEnum.Inbox || folder.type === FolderTypeEnum.Generic || folder.type === FolderTypeEnum.Deleted;
}
